<template>
  <footer class="footer">
    <div id="fb-root" />
    <div
      v-if="loadedMore"
      class="container desktopContent pt-4"
    >
      <div class="footerColumns">
        <!-- <div class="footerColumns" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"> -->
        <div class="row">
          <div class="col-lg-3 col-md-4">
            <ul class="linkList list-unstyled m-0">
              <li
                v-for="(item, i) in items.left_side_menu"
                :id="`footer-left_menu-${i}`"
                :key="`footer-left_menu-${i}`"
              >
                <CustomLink :url="item.url">
                  {{ item.name }}
                </CustomLink>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-4">
            <ul class="linkList list-unstyled m-0">
              <li
                v-for="(item, i) in items.right_side_menu"
                :id="`footer-right_menu-${i}`"
                :key="`footer-right_menu-${i}`"
              >
                <CustomLink :url="item.url">
                  {{ item.name }}
                </CustomLink>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-4 pl-0">
            <!-- <iframe
              src="//lightwidget.com/widgets/f456085db398547a90732959cbe0724f.html"
              id="lightwidget_f456085db3"
              name="lightwidget_f456085db3"
              scrolling="no"
              allowtransparency="true"
              class="lightwidget-widget"
              style="width: 100%; height: 270px;border: 0; overflow: hidden;"
            ></iframe>-->
            <div class="elfsight-app-cbdfa816-ca3e-4fbf-958e-3b5f78520897" />
          </div>
          <div class="col-lg-3 col-md-5">
            <div
              class="fb-page"
              data-href="https://www.facebook.com/opsantahk/"
              data-tabs="timeline"
              data-height="270"
              data-small-header="false"
              data-adapt-container-width="true"
              data-hide-cover="false"
              data-show-facepile="true"
            >
              <blockquote
                cite="https://www.facebook.com/opsantahk/"
                class="fb-xfbml-parse-ignore"
              >
                <a
                  href="https://www.facebook.com/opsantahk/"
                  target="_blank"
                  class="text-white"
                >{{ $t('app_title') }}</a>
              </blockquote>
            </div>
          </div>
          <div class="col-lg-12 col-md-7 align-self-end">
            <div
              v-view.once
              class="animated fadeInLeft"
            >
              <div class="box_aside float-left">
                <div class="icon fa fa-info-circle" />
              </div>
              <div class="box_cnt__no-flow">
                <h3 class="font-weight-light text-white">
                  {{ $t('footer.enquiry_title') }}
                </h3>
                <p
                  class="mb-0"
                  v-html="$t('footer.enquiry_msg', { tel: telephone, email: email })"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-4 mb-0">
    </div>
    <div class="container footerContent text-light">
      <div class="row">
        <div
          class="copyright col-md-9"
          v-html="$t('message.copyright', { osc_year: new Date().getFullYear() })"
        />
        <div class="lang_selector col-md-3">
          <template v-for="(lang, i) in languages">
            <span
              v-if="i>0"
              :key="`lang-sp${i}`"
            >|</span>
            <b-button
              :key="`lang-${ lang.locale }`"
              variant="link"
              class="lang_selector_btn"
              :class="$i18n.locale === lang.locale? 'active': ''"
              @click="switchLanguage(lang.locale)"
            >
              {{ lang.name }}
            </b-button>
          </template>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-dark totop d-none d-md-block"
      @click="scrollTo('body')"
    >
      <i class="fa fa-angle-up" />
    </button>
  </footer>
</template>
<script>
import CustomLink from "@/components/CustomLink";

export default {
  name: "Footer",
  components: { CustomLink },
  data: function() {
    return {
      osc_year: localStorage.osc_year,
      // telephone: localStorage.telephone,
      telephone: `<a href="tel:${localStorage.telephone}">(852) ${
        localStorage.telephone
      }</a>`,
      email: `<a href="mailto:${localStorage.email}">${localStorage.email}</a>`,
      items: [],
      loadedMore: false,
      languages: [
        {
          name: "English",
          locale: "en"
        },
        {
          name: "中文",
          locale: "zh"
        }
      ]
      // backgroundImage: this.getAssetLink(
      //   "/assets/media/theme/footer_logo_WiseGiving.png"
      // )
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    loadFacebook() {
      if (!this.loadedMore) {
        window.fbAsyncInit();
        let script = document.createElement("script");
        script.setAttribute("src", "https://apps.elfsight.com/p/platform.js");
        document.getElementsByTagName("footer")[0].appendChild(script);

        //   (function(d, s, id) {
        //     var js,
        //       fjs = d.getElementsByTagName(s)[0];
        //     if (d.getElementById(id)) return;
        //     js = d.createElement(s);
        //     js.id = id;
        //     js.src =
        //       "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.7&appId=395539110563623";
        //     fjs.parentNode.insertBefore(js, fjs);
        //   })(document, "script", "facebook-jssdk");
        this.loadedMore = true;
      }
    },
    init() {
      this.loadedMore = false;
      this.$http
        .get("footer")
        .then(response => {
          if (response.data.data) {
            localStorage.setItem("footer", JSON.stringify(response.data.data));
          }
        })
        .finally(() => {
          var items = localStorage.getItem("footer");
          if (items) {
            this.items = JSON.parse(items);
            this.loadFacebook();
          }
        });
    },
    switchLanguage(locale = null) {
      if (locale != null) this.$i18n.locale = locale;
      localStorage.locale = this.$i18n.locale;
      new Promise(resolve => this.$emit("refresh", resolve)).then(success => {
        if (success) {
          this.init();
        }
      });
    }
  }
};
</script>

